import { show, hide } from "./Helpers/helpers";
import { ProductAIS } from "./AIS/ProductAIS";

export const selectCallback = function (variant, selector) {
    let variantId = document.querySelector(
        ".product-" + selector.product.id + ' .shopify-product-form [name="id"]'
    )?.value;
    let productAis = new ProductAIS(variantId);

    let $product = $(".product-" + selector.product.id);
    let $productForm = $(".product_form, .shopify-product-form", $product);
    let variantInventory = $productForm.data("variant-inventory");
    const klaviyoBisBtns = document.querySelectorAll(".klaviyo-bis-trigger");

    if (variant) {
        let wishlistVariant = document.querySelector(".product_section [data-js-wishlist-add-variant]");
        if (wishlistVariant) {
            wishlistVariant.dataset.jsWishlistAddVariant = variant.id;
        }
        document.dispatchEvent(new CustomEvent("luc:variant:changed", { detail: { variantId: variant.id } }));
    }

    // Emits custom event
    const $selectDropdown = $productForm.find("[data-variant-selector]");
    $selectDropdown.trigger("selectedVariantChanged");
    if (variant) {
        if (variantInventory) {
            variantInventory.forEach(function (v) {
                if (v.id === variant.id) {
                    //TODO: potentially doesn't go to anything essential
                    variant.inventory_quantity = v.inventory_quantity;
                    variant.inventory_management = v.inventory_management;
                    variant.inventory_policy = v.inventory_policy;
                }
            });
        }
        $(".sku", $product).text("STYLE NO." + variant.sku);
        for (let i = 0, length = variant.options.length; i < length; i++) {
            let radioButton = $productForm.find(
                '.swatch[data-option-index="' +
                    escape(i) +
                    '"] :radio[value="' +
                    variant.options[i].replace(/"/g, '\\"') +
                    '"]'
            );
            if (radioButton.length) {
                radioButton.get(0).checked = true;
            }
        }
    }
    if (variant && variant.available == true) {
        if (variant.inventory_management && variant.inventory_quantity > 0) {
            if (variant.inventory_policy == "deny") {
                $("[data-max-inventory-management]", $product).attr("max", variant.inventory_quantity);
                // Check to see if quantity selector should be disabled based on inventory remaining
            }
        } else {
            $(".items_left", $product).text("");
            $("[data-max-inventory-management]", $product).removeAttr("max");
        }

        $(".sold_out", $product).text("");
        $(".cart-warning", $product).text("");

        let priceWithFormat = Shopify.formatMoney(variant.price, $("body").data("money-format")).split(".");
        if (priceWithFormat[1]) {
            if (parseInt(priceWithFormat[1]) > 0) {
                priceWithFormat = Shopify.formatMoney(variant.price, $("body").data("money-format"));
            } else {
                priceWithFormat = priceWithFormat[0];
            }
        } else {
            priceWithFormat = priceWithFormat[0];
        }
        $("[data-product-price]", $product).html('<span class="money">' + priceWithFormat + "</span>");

        klaviyoBisBtns.forEach((klaviyoBisBtn) => {
            hide(klaviyoBisBtn, true);
        });

        $(".shopify-payment-button", $product).show();
        $("[data-delivery-date]").show();
        if ($(".product-page").hasClass("template-shop-by-look")) {
            $('[data-sbl-product-id="' + selector.product.id + '"]').attr("disabled", false);
            $('[data-sbl-product-wrapper="' + selector.product.id + '"] .sbl-product__sold-out').addClass("hidden");
            LUC.jsProduct.calculateSblPrice();
        }

        $("[data-add-to-cart-trigger]").css({
            visibility: "visible",
            position: "relative",
            display: "inline-block",
        });
        productAis.hideAllCTATypes(selector.product.id);
        productAis.showCTAType(selector.product.id, "atc");
        productAis.setMTOVisibility(selector.product.id, variant);
    } else {
        let message = variant ? Shopify.translation.soldOut : Shopify.translation.unavailable;

        $("[data-max-inventory-management]", $product).removeAttr("max");
        $(".sold_out", $product).text(message);

        klaviyoBisBtns.forEach((klaviyoBisBtn) => {
            show(klaviyoBisBtn, true);
            klaviyoBisBtn.classList.add("!tw-block");
        });

        $(".shopify-payment-button", $product).hide();
        $(".purchase-buttons__divider", $product).hide();
        $(".purchase-buttons__more-options", $product).hide();
        $("[data-delivery-date]").hide();
        if ($(".product-page").hasClass("template-shop-by-look")) {
            $('[data-sbl-product-id="' + selector.product.id + '"]')
                .prop("checked", false)
                .attr("disabled", true);
            $('[data-sbl-product-wrapper="' + selector.product.id + '"] .sbl-product__sold-out').removeClass("hidden");
            LUC.jsProduct.calculateSblPrice();
        }

        $("[data-add-to-cart-trigger]").css({
            visibility: "hidden",
            position: "relative",
            display: "none",
        });
        productAis.checkAvailabilityForCTO(selector.product.id);
    }
};
